import { WS_PHONE } from "./utils";

export default function WSButton() {
	return (
		<div
			className="fixed right-4 md:right-10 bottom-14 bg-white rounded-full 
             shadow-xl h-20 md:h-24 flex justify-center
                hover:bg-dgwhite
            "
		>
			<a
				href={`https://wa.me/${WS_PHONE}`}
				target="_blank"
				rel="noreferrer"
				className="m-auto"
			>
				<img
					src="/images/wsbutton.png"
					className="h-20 md:h-24  p-4 md:p-5"
					alt="whatsapp button"
				/>
			</a>
		</div>
	);
}
